(() => {
  const menu = document.getElementById('mobile-nav');
  const menuButton = document.querySelector('[data-menu-open]');
  const closeMenu = () => {
    if (!menu || !menuButton) return;
    menu.classList.remove('is-open');
    menuButton.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    window.setTimeout(() => { menu.hidden = true; }, 220);
  };
  menuButton?.addEventListener('click', () => {
    if (!menu) return;
    menu.hidden = false;
    menuButton.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => menu.classList.add('is-open'));
  });
  document.querySelectorAll('[data-menu-close]').forEach(button => button.addEventListener('click', closeMenu));

  const initialize = (root = document) => {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      const select = section.querySelector('[data-variant-select]');
      if (!select || select.dataset.ready) return;
      select.dataset.ready = 'true';
      const variants = JSON.parse(section.querySelector('[data-variants]').textContent);
      select.addEventListener('change', () => {
        const variant = variants.find(item => String(item.id) === select.value);
        if (!variant) return;
        section.querySelectorAll('[data-price]').forEach(el => { el.textContent = variant.price; });
        section.querySelector('[data-availability]').textContent = variant.available ? 'På lager' : 'Udsolgt';
        section.querySelectorAll('[data-buy]').forEach(button => {
          button.disabled = !variant.available;
          button.textContent = variant.available ? 'Læg i kurv' : 'Udsolgt';
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        history.replaceState({}, '', url);
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    closeMenu();
    document.querySelectorAll('.mobile-menu[open], .nav-dropdown[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
})();
